import columns from '../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';

export const getDetailsTabNavOptions = reqParams => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.TRACKED_ITEMS_IN_PREDES_DETAILS.id,
    mainReportId: ReportDefinitions.TRACKED_ITEMS_IN_PREDES_SUMMARY.id,
    requestParams: {
      operFrom: rowInfo.row.sender,
      excludeEtoes: reqParams.excludeEtoes,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {}
);

export default (data, reqParams) => {
  const {
    TextColumn,
    NavigationColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'upu3CharSender'),
        new TextColumn('Sender', 'sender').withShow(false),
      ],
    },
    {
      Header: 'Items',
      columns: [
        new NonZeroNumberColumn('Total', 'items.total'),
        new NonZeroNumberColumn('With PREDES', 'items.withPredes'),
        new NonZeroNumberColumn('With EMC', 'items.withEmc'),
        new NavigationColumn(new NonZeroNumberColumn('Without PREDES', 'items.withoutPredes'), getDetailsTabNavOptions(reqParams)),
        new NonZeroPercentageColumn('%', 'items.pct'),
      ],
    },
  ];
};
